import Component from '@bythepixel/component-loader';
import { Map, NavigationControl } from 'mapbox-gl';
import LngLat from './lngLat';
import LngLatBounds from './lngLatBounds';
import MapMarker from './mapMarker';

export default class MapView extends Component {
  static selector = '[data-comp-map]'
  #map
  #bounds
  #markers = []

  constructor(element) {
    super(element);
    this.#bounds = new LngLatBounds(undefined, undefined);
    this.createMapboxMap();
  }

  get() {
    return this.#map;
  }

  getBounds() {
    return this.#bounds;
  }

  createMapboxMap() {
    this.#map = new Map({
      accessToken: 'pk.eyJ1IjoiYnl0aGVwaXhlbCIsImEiOiJjazZsY25lMHgwYWM4M2pwZHhqYWsxNG82In0.DWVg1VIrPntA6-sJAzzFAA',
      container: this.$container,
      // Options: https://docs.mapbox.com/api/maps/#mapbox-styles
      style: 'mapbox://styles/mapbox/outdoors-v11',
      // interactive: false,
      fitBoundsOptions: {
        padding: {
          top: 80,
          left: 20,
          right: 20,
          bottom: 20,
        },
      },
      AnimationOptions: {
        animate: false,
      },
      PaddingOptions: {
        top: 80,
        left: 20,
        right: 20,
        bottom: 20,
      },
      // scrollZoom: false,
      // boxZoom: false,
    });
    this.#map.addControl(new NavigationControl(), 'bottom-right');
  }

  addMarker(data) {
    const latLng = new LngLat(data.latitude, data.longitude);
    this.#bounds.add(latLng.get());
    this.#markers[data.id] = new MapMarker(data, this.#map);
    return this.#markers[data.id];
  }

  fitBounds(bounds = this.#bounds.get()) {
    this.#map.resize();
    this.#map.fitBounds(bounds, { padding: 100 });
  }

  flyTo(options) {
    this.#map.flyTo(options);
  }

  setCenter(lat, lng) {
    this.#map.setCenter(new LngLat(lat, lng).get());
  }

  setZoom(z) {
    this.#map.setZoom(z);
  }

  on(event, cb) {
    this.#map.on(event, cb);
  }
}
